import templateUrl from './pay-stub-entry.component.html'
import './pay-stub-entry.component.less'

export const PayStubEntryComponent = {
    templateUrl,
    bindings: {
        payStubEntry: "<",
        useDailyRSCommission: "<useDailyRsCommission"
    },
    controllerAs: "vm"
}
